<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="TPO: Team"
                   :links="[{title:'Home', url:'/'},{title:'TPO', url: ''}, {title: 'Team'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="3"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">TPO: Team</div>
          <team-card class="mb-5" v-for="(staff, index) in staffList" :key="index" :staff="staff"></team-card>
        </section>

      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/tpo/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import TeamCard from "@/components/TeamCard";

export default {
  name: "About",
  components: {
    KeyRecruiters,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    TeamCard
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      staffList: [
        {
          name: 'Prof. Solanki A.M. ',
          image: 'Amit Solanki',
          designation: 'TPO',
          contact: '9893577098',
          email: 'sndcoerctrainingplacement@gmail.com'
        }, {
          name: 'Prof. Kulkarni V.K.',
          image: 'Kulkarni V V',
          designation: 'Assistant TPO & TPC Civil Engineering ',
          contact: '9850194749',
          email: 'vivekkulkarni273@gmail.com'
        }, {
          name: 'Prof. Barvakar P.S.',
          image: 'Baravkar P S',
          designation: 'TPC Mechanical Engineering',
          contact: '8149386507',
          email: 'pavanbaravkar49@gmail.com'
        }, {
          name: 'Prof. Waghmare A. I.',
          image: 'waghamre sir',
          designation: 'TPC Information Technology',
          contact: '8830404872',
          email: 'arunwaghmare@gmail.com'
        }, {
          name: 'Prof. Bharambe I. N.',
          image: 'I. N. Bharambe',
          designation: 'TPC Computer Engineering',
          contact: '9595434525',
          email: 'ishwar.bharambe@gmail.com'
        }, {
          name: 'Prof. Gaikwad S.B.',
          image: 'Gaikwad S B',
          designation: 'TPC  E & TC',
          contact: '7841830068',
          email: 'gaikwadsumitra3@gmail.com'
        },
      ]
    }
  }
}
</script>
<style lang="scss" scoped/>
